import CryptoJS from "crypto-js";
import { AES_SECRET_KEY } from "../../keys";

export const encrypt = (plainText: string): string => {
  try {
    if (!plainText) {
      return plainText;
    }
    const cipherText = CryptoJS.AES.encrypt(
      plainText,
      AES_SECRET_KEY
    ).toString();
    return cipherText;
  } catch {
    return plainText;
  }
};

export const decrypt = (cipherText: string): string => {
  try {
    if (!cipherText) {
      return cipherText;
    }
    const bytes = CryptoJS.AES.decrypt(cipherText, AES_SECRET_KEY);
    const plainText = bytes.toString(CryptoJS.enc.Utf8);
    return plainText;
  } catch {
    return cipherText;
  }
};
